import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues3, KeyValueSet, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-language-container',
  templateUrl: './language-container.component.html',
  styleUrls: ['./language-container.component.scss']
})
export class LanguageContainerComponent implements OnInit {
  @Input() Title = ''; @Input() isModeChangeAllowed = true;
  @Input() IsLargeText = false; @Input() id = ''; @Input() nextId = '';
  @Input() languageContents: KeyValues3[]; @Input() IsAllMandatory = false; @Input() IsPartiallyMandatory = false; @Input() IsNeedNewLine = false;
  @Input() MandatoryLanguages = []; @Input() MaxLength; @Input() IsCustomLanguageRequired = false;
  @Input() IsAlwaysEditable = true; @Input() isShowClear = true; @Input() isSetProperEnglish = true;
  @Input() isLockAutoSenseTranslate = false;
  @Input() IsShowAllLanguages = false; @Input() IsShowTransliterate = false; itemMandatory: KeyValues3; itemCustom: KeyValues3;
  @Output() onEmptyLanguageContainerAdded = new EventEmitter();
  @Output() languageContentsChange = new EventEmitter<any>();
  @Output() isOnlyTransliterate = false;
  isShowOtherLanguages = false; customLanguageId: string = '000000000000000000000000';
  constructor(public localService: LocalService, public languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    if (!this.MaxLength) {
      this.MaxLength = this.localService.maxIntegerLength;
    }
    if (this.id == '')
      this.id = this.localService.getRandomString(5);
    //this.onChanges();
    this.setMandatoryItem();
  }

  ngOnChanges(): void {
    setTimeout(() => { //To avoid NG0100 error
      this.onChanges();
    }, 0);
  }

  onChanges() {
    this.setMandatoryItem();
    this.onLoad(true);
  }

  onLoad(isLoadEmptyContainer = false) {
    if (isLoadEmptyContainer) {
      this.onLoadEmptyContainer();
    }
  }

  isShowLanguage(languageId: string) {
    var items = this.IsShowAllLanguages ? this.localService.languagesEquivalent.filter(x => x.v1 == languageId) : this.localService.languagesEquivalent.filter(x => x.isSelected && x.v1 == languageId);
    return items.length > 0;
  }

  onLoadEmptyContainer() {
    let languages = this.IsShowAllLanguages ? this.localService.languagesEquivalent : this.localService.languagesEquivalent.filter(x => x.isSelected);
    if (!this.languageContents || this.languageContents.length == 0) {
      this.languageContents = [];
      languages.forEach(x => {
        this.languageContents.push({ key: '', v1: x.v1, v2: x.v3, v3: '' } as KeyValues3);
      });
      this.onEmitValues();
    } else if (this.languageContents && this.languageContents.length > 0) {
      if (!this.IsAlwaysEditable) {
        this.languageContents.forEach(languageWrapper => {
          languageWrapper.isReadonly = languageWrapper.key && languageWrapper.key != '' && languageWrapper.v3 != '';
        });
      }
      languages.forEach(x => {
        if (this.languageContents.filter(item => item.v1 == x.v1).length == 0)
          this.languageContents.push({ key: '', v1: x.v1, v2: x.v3, v3: '' } as KeyValues3);
        else
          this.languageContents.find(item => item.v1 == x.v1).v2 = x.v3;
      });
      this.onEmitValues();
      this.isShowOtherLanguages = false;
    }
  }

  getLanguageValue(index: number, languageId: string) {
    let item = this.localService.languages.find(x => x.key == languageId);
    if (item != undefined) {
      switch (index) {
        case 1: {
          return item.v3;
        }
        case 2: {
          return this.localService.getLanguageCode(item.key);
        }
        case 3: {
          return item.v2 == null || item.v2 == '' ? '' : item.v2;
        }
        default: {
          return '-';
        }
      }
    } else
      return '-';
  }

  onShowHideOtherLanguages() {
    this.isShowOtherLanguages = !this.isShowOtherLanguages;
    this.localService.onFocusNextInput(this.id + "_m", FocusInputType.TextBox);
  }

  onEmitValues() {
    if (this.languageContents && this.languageContents.length > 0 && this.IsCustomLanguageRequired) {
      let customItem = this.languageContents.find(x => x.v1 == this.customLanguageId);
      if (customItem) {
        customItem = this.itemCustom;
      } else {
        this.languageContents.push(this.itemCustom);
      }
    }

    this.languageContents.forEach(x => {
      if (x) {
        x.isSelected = this.isOnlyTransliterate;
      }
    });
    this.onEmptyLanguageContainerAdded.emit(this.languageContents);
  }

  onFocus(currentRow) {
    let navigateToId = this.id + '_' + (currentRow + 1);
    if (navigateToId != '') {
      let elementToFocus = document.getElementById(navigateToId) as HTMLInputElement;
      if (elementToFocus) {
        elementToFocus.focus();
      } else
        this.focusToNextId();
    }
  }

  onSetTranliteration() {
    if (this.isOnlyTransliterate) {
      const englishId = this.languageManagementService.getEnglishLanguageId();
      this.languageContents.forEach(x => {
        if (x.v1 != englishId) {
          x.v3 = '';
        }
      });
    }
    this.onEmitValues();
  }

  focusToNextId() {
    if (this.nextId) {
      let elementToFocusNext = document.getElementById(this.nextId) as any;
      if (elementToFocusNext) {
        elementToFocusNext.focus();
        return false;
      }
    }
    return true;
  }

  isEnableAutoTranslation(): boolean {
    let rtn = false;
    rtn = this.languageContents.filter(x => x.v3 && x.v3.trim() != '').length > 0
      && this.languageContents.filter(x => x.v3 && x.v3.trim() != '').length != this.languageContents.length;
    return rtn;
  }

  onAutoTranslate() {
    let languageIds: KeyValueSet[] = this.languageContents.filter(x => x.v3.trim() == '').map(function (x) {
      return { key: x.v1, value: "" } as KeyValueSet;
    });
    if (languageIds.length > 0) {
      languageIds.forEach(x => {
        x.value = this.localService.getLanguageCode(x.key);
      });
      let item = this.languageContents.filter(x => x.v3.trim() != '')[0];
      this.languageManagementService.getTranslatedTextByLanguages(languageIds.map(x => x.value), item.v3, this.localService.getLanguageCode(item.v1), this.isOnlyTransliterate).subscribe(result => {
        result.forEach(item => {
          let languageId = languageIds.find(x => x.value == item.key).key;
          this.languageContents.find(x => x.v1 == languageId).v3 = item.value;
          this.onSetProperEnglish();
        });
      });
    }
  }

  onClear() {
    this.languageContents.forEach(x => x.v3 = "");
    this.localService.onFocusNextInput(this.id + "_m", FocusInputType.TextBox);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.IsLargeText = !this.IsLargeText;
      } break;
    }
  }

  setMandatoryItem() {
    if (this.languageContents) {
      if (this.languageContents && this.languageContents.filter(x => !x).length > 0)
        this.languageContents = this.languageContents.filter(x => x);
      let englishId = this.languageManagementService.getEnglishLanguageId();
      this.MandatoryLanguages = this.MandatoryLanguages.filter(x => x != englishId);
      if (this.MandatoryLanguages.length == 0) {
        this.MandatoryLanguages.push(this.localService.getSelectedLanguageId());
      }
      if (this.MandatoryLanguages.length > 0) {
        if (this.languageContents.filter(x => x.v1 == this.MandatoryLanguages[0] && x.v3).length == 0 && this.languageContents.filter(x => x.v3).length > 0) {
          this.MandatoryLanguages = [];
          if (this.languageContents.filter(x => x.v1 == englishId && x.v3).length > 0) {
            this.MandatoryLanguages.push(englishId);
          } else {
            if (this.languageContents.filter(x => x.v3).length > 0) {
              this.MandatoryLanguages.push(this.languageContents.filter(x => x.v3)[0].v1);
            } else {
              this.MandatoryLanguages.push(englishId);
            }
          }
        } else {
          this.MandatoryLanguages.push(englishId);
        }
      } else {
        this.MandatoryLanguages.push(englishId);
      }
      this.itemMandatory = this.languageContents.find(x => x.v1 == this.MandatoryLanguages[0]);
      if (this.IsCustomLanguageRequired) {
        let tempItemCustom = this.languageContents.find(x => x.v1 == this.customLanguageId);
        this.itemCustom = tempItemCustom ?? { key: '', v1: this.customLanguageId, v2: '', v3: '' } as KeyValues3;
      }
    }
  }

  ngOnDestroy(): void {
    //this.languageContents = null;
    //this.onEmptyLanguageContainerAdded.emit(this.languageContents);
  }

  onCheckEnglishLanguage() {
    if (!this.isLockAutoSenseTranslate) {
      this.onSetProperEnglish();
      if (this.languageContents.filter(x => x.v3.trim()).length == 1) {
        const item = this.languageContents.filter(x => x.v3.trim())[0];
        const englishId = this.languageManagementService.getEnglishLanguageId();
        if (item.v1 != englishId) {
          if (this.localService.isOnlyEnglishLanguage(item.v3.trim())) {
            this.languageContents.filter(x => x.v1 == englishId)[0].v3 = item.v3;
            this.languageContents.filter(x => x.v1 != englishId && x.v3.trim())[0].v3 = '';
            this.onAutoTranslate();
          }
        }
      }
    }
  }

  onSetProperEnglish() {
    if (!this.isLockAutoSenseTranslate && this.isSetProperEnglish) {
      const englishId = this.languageManagementService.getEnglishLanguageId();
      const itemLanguage = this.languageContents.find(x => x.v1 == englishId);
      if (itemLanguage) {
        const name = itemLanguage.v3.trim();
        const names = name.split(' ');
        let title = '';
        names.forEach(item => {
          title += item.substring(0, 1).toUpperCase() + (item.length > 1 ? item.substring(1, item.length) : '') + ' ';
        });
        this.languageContents.filter(x => x.v1 == englishId)[0].v3 = title.trim();
      }
    }
  }

  onClearOtherLanguage() {
    if (!this.isLockAutoSenseTranslate) {
      this.languageContents.filter(x => x.v1 != this.itemMandatory.v1).forEach(item => {
        item.v3 = '';
      });
    }
  }
}
